import { track } from "@/lib/analytics";

export function ActivationAudioPlayer({ src, title }: { src: string; title?: string }) {
  return (
    <section className="rounded-xl border hairline bg-charcoal p-6">
      <p className="text-xs uppercase tracking-[0.3em] text-gold">Audio Transmission</p>
      {title && <p className="mt-2 font-serif text-lg text-ivory">{title}</p>}
      <audio
        controls
        preload="metadata"
        src={src}
        onPlay={() => track("activation_play", { title, media: "audio" })}
        className="mt-4 w-full"
      >
        Your browser does not support the audio element.
      </audio>
    </section>
  );
}

export function ActivationVideoPlayer({ src, poster }: { src: string; poster?: string | null }) {
  return (
    <section className="overflow-hidden rounded-xl border hairline bg-black">
      <video
        controls
        playsInline
        preload="metadata"
        src={src}
        poster={poster ?? undefined}
        onPlay={() => track("activation_play", { media: "video" })}
        className="w-full"
      >
        Your browser does not support the video element.
      </video>
    </section>
  );
}
